import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Button, Form, Grid, Header, Image, Message} from 'semantic-ui-react';
import { forgotPassword, clearErrorCode } from '../../core/actions/authAction';
import './styles.scss';
import {
    Link
} from "react-router-dom";
import { withTranslation  } from "react-i18next";
import { compose } from 'redux';
import logoUrl from '../../assets/images/logo.png';

class ForgotPassword extends Component {
    state = { 
        email: '',
        submitted: false,
        loading: false,
        error: '',
        btnDisable: false
    }
    
    componentWillReceiveProps() {
        this.setState({ btnDisable: false });
    }

    handleChange = (e, { name, value }) => {
        this.props.clearErrorCode();
        this.setState({ [name]: value });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.setState({ submitted: true });
        const {email} = this.state;

        if (email) {
            this.props.forgotPassword({'email':email});
            this.setState({ btnDisable: true });
        }
    }

    errorMessage = () => {
        const {t} = this.props; 
        return(
            <div className="error-message">
                { this.props.authReducer.errorCode ? t("message." + this.props.authReducer.errorCode) : ''}
            </div>
        )
    }

    successMessage = () => {
        const {t} = this.props; 
        return(
            <div className="success-message">
                { this.props.authReducer.successCode ? t("message." + this.props.authReducer.successCode) : ''}
            </div>
        )
    }

    render() {
        const {t} = this.props;  
        const { email, submitted, btnDisable} = this.state;
        // Reset form input on IE
        window.addEventListener('pageshow', () => {
            this.setState({email: ''})
        });
        return (
            <Grid textAlign='center' verticalAlign='middle' className="account-wrapper">
                <div className="account-container">
                    <Grid.Column className="p-0">
                        <Header textAlign='left' className="account-form-header">
                            <Image src={logoUrl} className="account-form-logo" />
                            <h2 className="account-form-title">{t("account.forgotPassword")}</h2>
                        </Header>
                        <p align='center' className="sub-title">{t("account.sendLink")}</p>
                        <Form size='large' onSubmit={this.handleSubmit} error>
                            {this.props.authReducer.errorCode ? this.errorMessage() : ''}
                            {this.props.authReducer.successCode ? this.successMessage() : ''}
                            <Form.Input
                                fluid
                                icon='mail'
                                iconPosition='left'
                                placeholder={t("account.enterEmail")}
                                type='email'
                                name='email'
                                onChange={this.handleChange}
                                value={email}
                            />
                            { submitted && !email &&
                                <div className="error-message">{t("validation.emailRequired")}</div>
                            } 
                            <Button disabled={btnDisable} fluid size='large' className="account-form-btn">
                            {t("account.send")}
                            </Button>
                        </Form>            
                        <Message className="account-form-message">
                            <a className="link" onClick={e => {window.location = '/login'}}>{t("account.backLogin")}</a>
                        </Message>
                    </Grid.Column>
                </div>
            </Grid>
        );
    }
}

const mapStateToProps = state => ({
    ...state
})

const mapDispatchToProps = dispatch => ({
    forgotPassword: (data) => dispatch(forgotPassword(data)),
    clearErrorCode: () => dispatch(clearErrorCode())
})

export default compose(
    withTranslation(),
    connect(mapStateToProps, mapDispatchToProps)
)(ForgotPassword);
